import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileService {

  constructor(public http: HttpClient) { }

  public export(path: string): Observable<Blob> {
    const headers = new HttpHeaders().set('skipLoader', 'true');
    return new Observable<any>(observer => {
      this.http.get(path, {
        headers: headers,
        responseType: 'blob',
      }).subscribe(
        data => {
          observer.next(data);
        },
        error => {
          observer.error(error);
        },
        () => observer.complete()
      )
    })
  }

}




